import { Dispatch } from 'react';
import TypeformComponentLayout from './typeform-component-layout';

type Props = {
    statementField: any,
    partialAnswersHook: [any, Dispatch<any>]
    stepperInfo?: [number, number],
    onComplete: () => void,
}

export default function TypeformStatement(props: Props): JSX.Element {
    const field = props.statementField;
    const [partialAnswers] = props.partialAnswersHook;
    const onClick = async () => {
        await props.onComplete();
    };
    return (
        <TypeformComponentLayout field={field}
            partialAnswers={partialAnswers}
            submitShown={true}
            submitEnabled={true}
            stepperInfo={props.stepperInfo}
            onSubmit={onClick}>
        </TypeformComponentLayout>
    );
}